import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import React__default, { useState, useRef, useEffect } from 'react';
import { a as _defineProperty, _ as _objectSpread2 } from '../_rollupPluginBabelHelpers-05128ded.js';
import { createPortal } from 'react-dom';
import SortByRow from './SortByRow.js';
import { h as getClassName } from '../index-579ca9d7.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import '../uuid-717930b4.js';
import '../utils/message/getOutgoingMessageState.js';
import 'prop-types';
import '../stringSet-b60e9529.js';

// padding to handle height of last item in message-list
var HEIGHT_PADDING = 60;
var MenuItems$1 = /*#__PURE__*/function (_React__default$Compo) {
  _inherits(MenuItems$1, _React__default$Compo);
  function MenuItems$1(props) {
    var _this;
    _classCallCheck(this, MenuItems$1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItems$1).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuRef", /*#__PURE__*/React__default.createRef());
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setupEvents", function () {
      var closeDropdown = _this.props.closeDropdown;
      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
        menuRef = _assertThisInitialize.menuRef;
      var handleClickOutside = function handleClickOutside(event) {
        var _menuRef$current, _menuRef$current$cont;
        if (menuRef !== null && menuRef !== void 0 && menuRef.current && !(menuRef !== null && menuRef !== void 0 && (_menuRef$current = menuRef.current) !== null && _menuRef$current !== void 0 && (_menuRef$current$cont = _menuRef$current.contains) !== null && _menuRef$current$cont !== void 0 && _menuRef$current$cont.call(_menuRef$current, event.target))) {
          closeDropdown === null || closeDropdown === void 0 ? void 0 : closeDropdown();
        }
      };
      _this.setState({
        handleClickOutside: handleClickOutside
      });
      document.addEventListener('mousedown', handleClickOutside);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cleanUpEvents", function () {
      var handleClickOutside = _this.state.handleClickOutside;
      document.removeEventListener('mousedown', handleClickOutside);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuPosition", function () {
      var _parentRef$current, _parentRef$current$ge;
      var _this$props2 = _this.props,
        parentRef = _this$props2.parentRef,
        openLeft = _this$props2.openLeft;
      var parentRect = parentRef === null || parentRef === void 0 ? void 0 : (_parentRef$current = parentRef.current) === null || _parentRef$current === void 0 ? void 0 : (_parentRef$current$ge = _parentRef$current.getBoundingClientRect) === null || _parentRef$current$ge === void 0 ? void 0 : _parentRef$current$ge.call(_parentRef$current);
      var x = (parentRect === null || parentRect === void 0 ? void 0 : parentRect.x) || (parentRect === null || parentRect === void 0 ? void 0 : parentRect.left) || 0;
      var y = (parentRect === null || parentRect === void 0 ? void 0 : parentRect.y) || (parentRect === null || parentRect === void 0 ? void 0 : parentRect.top) || 0;
      var menuStyle = {
        top: y,
        left: x
      };
      if (!_this.menuRef.current) return menuStyle;
      var _window = window,
        innerWidth = _window.innerWidth,
        innerHeight = _window.innerHeight;
      var rect = _this.menuRef.current.getBoundingClientRect();
      if (y + rect.height + HEIGHT_PADDING > innerHeight) {
        menuStyle.top -= rect.height;
      }
      if (x + rect.width > innerWidth && !openLeft) {
        menuStyle.left -= rect.width;
      }
      if (menuStyle.top < 0) {
        menuStyle.top = rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
      }
      menuStyle.top += 32;
      if (openLeft) {
        var padding = Number.isNaN(rect.width - 30) ? 108 // default
        : rect.width - 30;
        menuStyle.left -= padding;
      }
      // warning: this section has to be executed after the openLeft is calculated
      // menu is outside viewport
      if (menuStyle.left < 0) {
        menuStyle.left = rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
      }
      _this.setState({
        menuStyle: menuStyle
      });
      return menuStyle;
    });
    _this.state = {
      menuStyle: {},
      handleClickOutside: function handleClickOutside() {/* noop */}
    };
    return _this;
  }
  _createClass(MenuItems$1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupEvents();
      this.getMenuPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cleanUpEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props;
      var menuStyle = this.state.menuStyle;
      var _this$props3 = this.props,
        children = _this$props3.children,
        style = _this$props3.style,
        _this$props3$classNam = _this$props3.className,
        className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam;
      return /*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement("div", {
        className: (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.className
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "sendbird-dropdown__menu-backdrop"
      }), /*#__PURE__*/React__default.createElement("ul", {
        className: "".concat(className, " sendbird-dropdown__menu"),
        ref: this.menuRef,
        style: _objectSpread2({
          display: 'inline-block',
          position: 'fixed',
          left: "".concat(Math.round(menuStyle.left), "px"),
          top: "".concat(Math.round(menuStyle.top), "px")
        }, style)
      }, children)), document.getElementById('sendbird-dropdown-portal'));
    }
  }]);
  return MenuItems$1;
}(React__default.Component);
var defaultParentRect = {
  x: 0,
  y: 0,
  left: 0,
  top: 0,
  height: 0
};
var EmojiListItems$1 = function EmojiListItems$1(_ref) {
  var children = _ref.children,
    parentRef = _ref.parentRef,
    parentContainRef = _ref.parentContainRef,
    _ref$spaceFromTrigger = _ref.spaceFromTrigger,
    spaceFromTrigger = _ref$spaceFromTrigger === void 0 ? {
      x: 0,
      y: 0
    } : _ref$spaceFromTrigger,
    closeDropdown = _ref.closeDropdown;
  var _useState = useState({
      left: 0,
      top: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    reactionStyle = _useState2[0],
    setReactionStyle = _useState2[1];
  var reactionRef = useRef(null);

  /* showParent & hideParent */
  useEffect(function () {
    if (parentContainRef && parentContainRef !== null && parentContainRef !== void 0 && parentContainRef.current) {
      parentContainRef.current.classList.add('sendbird-reactions--pressed');
    }
    return function () {
      if (parentContainRef && parentContainRef !== null && parentContainRef !== void 0 && parentContainRef.current) {
        parentContainRef.current.classList.remove('sendbird-reactions--pressed');
      }
    };
  }, []);

  /* setupEvents & cleanupEvents */
  useEffect(function () {
    var handleClickOutSide = function handleClickOutSide(event) {
      var _reactionRef$current, _reactionRef$current$;
      if (reactionRef !== null && reactionRef !== void 0 && reactionRef.current && !(reactionRef !== null && reactionRef !== void 0 && (_reactionRef$current = reactionRef.current) !== null && _reactionRef$current !== void 0 && (_reactionRef$current$ = _reactionRef$current.contains) !== null && _reactionRef$current$ !== void 0 && _reactionRef$current$.call(_reactionRef$current, event.target))) {
        closeDropdown();
      }
    };
    document.addEventListener('mousedown', handleClickOutSide);
    return function () {
      document.removeEventListener('mousedown', handleClickOutSide);
    };
  }, []);

  /* getBarPosition */
  useEffect(function () {
    var _parentRef$current$ge, _parentRef$current;
    var spaceFromTriggerX = (spaceFromTrigger === null || spaceFromTrigger === void 0 ? void 0 : spaceFromTrigger.x) || 0;
    var spaceFromTriggerY = (spaceFromTrigger === null || spaceFromTrigger === void 0 ? void 0 : spaceFromTrigger.y) || 0;
    var parentRect = (_parentRef$current$ge = parentRef === null || parentRef === void 0 ? void 0 : (_parentRef$current = parentRef.current) === null || _parentRef$current === void 0 ? void 0 : _parentRef$current.getBoundingClientRect()) !== null && _parentRef$current$ge !== void 0 ? _parentRef$current$ge : defaultParentRect;
    var x = parentRect.x || parentRect.left;
    var y = parentRect.y || parentRect.top;
    var reactionStyle = {
      top: y,
      left: x
    };
    if (!(reactionRef !== null && reactionRef !== void 0 && reactionRef.current)) {
      setReactionStyle(reactionStyle);
    } else {
      var _reactionRef$current2;
      var rect = reactionRef === null || reactionRef === void 0 ? void 0 : (_reactionRef$current2 = reactionRef.current) === null || _reactionRef$current2 === void 0 ? void 0 : _reactionRef$current2.getBoundingClientRect();
      if (reactionStyle.top < rect.height) {
        reactionStyle.top += parentRect.height;
        reactionStyle.top += spaceFromTriggerY;
      } else {
        reactionStyle.top -= rect.height;
        reactionStyle.top -= spaceFromTriggerY;
      }
      reactionStyle.left -= rect.width / 2;
      reactionStyle.left += parentRect.height / 2 - 2;
      reactionStyle.left += spaceFromTriggerX;
      var maximumLeft = window.innerWidth - rect.width;
      if (maximumLeft < reactionStyle.left) {
        reactionStyle.left = maximumLeft;
      }
      if (reactionStyle.left < 0) {
        reactionStyle.left = 0;
      }
      setReactionStyle(reactionStyle);
    }
  }, []);
  var rootElement = document.getElementById('sendbird-emoji-list-portal');
  if (rootElement) {
    return /*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "sendbird-dropdown__menu-backdrop"
    }), /*#__PURE__*/React__default.createElement("ul", {
      className: "sendbird-dropdown__reaction-bar",
      ref: reactionRef,
      style: {
        display: 'inline-block',
        position: 'fixed',
        left: "".concat(Math.round(reactionStyle.left), "px"),
        top: "".concat(Math.round(reactionStyle.top), "px")
      }
    }, /*#__PURE__*/React__default.createElement(SortByRow, {
      className: "sendbird-dropdown__reaction-bar__row",
      maxItemCount: 8,
      itemWidth: 44,
      itemHeight: 40
    }, children))), rootElement);
  }
  return null;
};
var ENTER_KEY = 13;
var MenuItems = MenuItems$1;
var EmojiListItems = EmojiListItems$1;
var MenuItem = function MenuItem(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    onClick = _ref.onClick,
    _ref$disable = _ref.disable,
    disable = _ref$disable === void 0 ? false : _ref$disable,
    _ref$dataSbId = _ref.dataSbId,
    dataSbId = _ref$dataSbId === void 0 ? '' : _ref$dataSbId;
  var handleClickEvent = function handleClickEvent(e) {
    if (!disable && onClick) {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement("li", {
    className: getClassName([className, 'sendbird-dropdown__menu-item', disable ? 'disable' : '']),
    role: "menuitem",
    "aria-disabled": disable ? true : false,
    onClick: handleClickEvent,
    onKeyPress: function onKeyPress(e) {
      if (e.keyCode === ENTER_KEY) handleClickEvent(e);
    },
    tabIndex: 0,
    "data-sb-id": dataSbId
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-dropdown__menu-item__text",
    type: LabelTypography.SUBTITLE_2,
    color: disable ? LabelColors.ONBACKGROUND_4 : LabelColors.ONBACKGROUND_1
  }, children));
};
var MenuRoot = function MenuRoot() {
  return /*#__PURE__*/React__default.createElement("div", {
    id: "sendbird-dropdown-portal",
    className: "sendbird-dropdown-portal"
  });
};

// For the test environment
var EmojiReactionListRoot = function EmojiReactionListRoot() {
  return /*#__PURE__*/React__default.createElement("div", {
    id: "sendbird-emoji-list-portal"
  });
};
function ContextMenu(_ref2) {
  var menuTrigger = _ref2.menuTrigger,
    menuItems = _ref2.menuItems,
    isOpen = _ref2.isOpen;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showMenu = _useState4[0],
    setShowMenu = _useState4[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-context-menu",
    style: {
      display: 'inline'
    }
  }, menuTrigger === null || menuTrigger === void 0 ? void 0 : menuTrigger(function () {
    return setShowMenu(!showMenu);
  }), (showMenu || isOpen) && menuItems(function () {
    return setShowMenu(false);
  }));
}
export { EmojiListItems, EmojiReactionListRoot, MenuItem, MenuItems, MenuRoot, ContextMenu as default };